import { http } from "@/core/api/";

const apiUrl = "api/ProcessCertificationMonthlyServices";
export default {
  search(payload) {
    return http.get(`${apiUrl}/certificationmonthlyservices`, {
      params: {
        ...payload
      }
    });
  }
};
